import { PostMedia2, PostText, PostUserBlock } from "ui";

const CommentPost = () => {
    return (
        <div className=" thread-post">
            <div className="card is-post mb-20 mt-20">
                {/* <!-- Main wrap --> */}
                <div className={`content-wrap`}>
                    <div className="p-relative">
                        {/* main-thread */}
                        <div className={`thread-post-v-line`}></div>
                        {/* <!-- Post header --> */}
                        <div className="card-heading" style={{ paddingTop: 0 }}>
                            {/* <!-- User meta --> */}
                            <PostUserBlock />
                        </div>
                        {/* <!-- /Post header --> */}

                        <div className="thread-post-body">
                            {/* <!-- Post body --> */}
                            <div className="card-body">
                                {/* <!-- Post body text --> */}
                                <PostText text="Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!" />
                                {/* <!-- Featured image --> */}
                                <PostMedia2 />
                            </div>
                            {/* <!-- /Post body --> */}

                            {/* <!-- Post footer --> */}
                            <div className="card-footer">
                                <p className="momeento-p">
                                    Replying to <a href="#">@User</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommentPost;
